
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import SideBar from '../Components/SideBar';
import HeaderBar from '../Components/HeaderBar';
import useLayoutStore from '../../../Zustand/layoutStore';


const PanelBarNavContainer = (props: any) => {
  const store = useLayoutStore();

  /**
   * On mount, listen on page resize to determine if mobile responsive mode should be enabled.
   * set to switch at 1280px (tailwind xl) so tablets/iPad (both orientations) start collapsed
   */
  React.useEffect(() => {
    // Declare resize function
    function handleResize() {
      if (window.innerWidth < 1280) {
        store.setIsSidebarOpen(false);
      } else {
        store.setIsSidebarOpen(true);
      }
    }
    // Run once on mount so initial state respects screen size
    handleResize();
    //Set up listener
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOutOfSidebarClick = () => {
    if (window.innerWidth < 1280) {
      store.setIsSidebarOpen(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col custom-toolbars">
      <HeaderBar />
      <div className="flex h-full w-full flex-grow">
        <SideBar />
        {store.isSidebarOpen && window.innerWidth < 1280 && (
          <div onClick={handleOutOfSidebarClick} className="gb-overlay" />
        )}

        <div className="h-full flex-1 min-w-0">
          {props.children}
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default PanelBarNavContainer;
